import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=043fc2c4"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports